/**
 * <product-card>
 * - Quick add: size buttons set the variant id and submit the Dawn <product-form>.
 * - Mobile "+" toggle reveals the size row.
 * Relies on product-form.js (loaded by the section) for the actual cart request.
 */
if (!customElements.get('product-card')) {
  customElements.define(
    'product-card',
    class ProductCard extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('.product-card__quick-toggle');
        this.form = this.querySelector('form');
        this.submit = this.querySelector('.product-card__submit') || this.querySelector('.product-card__size--single');
        this.idInput = this.form?.querySelector('input[name="id"]');

        this.toggle?.addEventListener('click', (e) => {
          e.preventDefault();
          const open = !this.classList.contains('is-open');
          this.classList.toggle('is-open', open);
          this.toggle.setAttribute('aria-expanded', String(open));
          if (open) this.querySelector('.product-card__size:not([disabled])')?.focus();
        });

        this.querySelectorAll('.product-card__size[data-variant-id]').forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            if (btn.hasAttribute('disabled') || !this.idInput || !this.form) return;
            this.idInput.value = btn.dataset.variantId;
            this.classList.add('is-adding');
            btn.classList.add('loading');
            this.activeSize = btn;
            if (this.form.requestSubmit) this.form.requestSubmit(this.submit);
            else this.submit?.click();
          });
        });

        if (this.form) {
          this.form.addEventListener('submit', () => {
            this.classList.add('is-adding');
          });
        }

        document.addEventListener('click', this.onDocumentClick);

        if (window.subscribe && window.PUB_SUB_EVENTS) {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (payload) => {
            if (payload?.source !== 'product-form') return;
            this.finish(true);
          });
          this.unsubscribeError = subscribe(PUB_SUB_EVENTS.cartError, () => this.finish(false));
        }
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        this.unsubscribe?.();
        this.unsubscribeError?.();
      }

      onDocumentClick = (e) => {
        if (!this.classList.contains('is-open')) return;
        if (this.contains(e.target)) return;
        this.classList.remove('is-open');
        this.toggle?.setAttribute('aria-expanded', 'false');
      };

      finish(success) {
        if (!this.classList.contains('is-adding')) return;
        const btn = this.activeSize;
        btn?.classList.remove('loading');
        if (success && btn) {
          btn.classList.add('is-added');
          setTimeout(() => btn.classList.remove('is-added'), 1200);
        }
        this.classList.remove('is-adding', 'is-open');
        this.toggle?.setAttribute('aria-expanded', 'false');
        this.activeSize = null;
      }
    }
  );
}
